export default __webpack_public_path__ + "static/media/logo_v.0c89d769.svg";